<template>
   <div class="layout">
        <div class="layout__header">
            <h3>Tipos de unidad</h3>
        </div>
        <k-table :filterStatus="filterStatus" @crear="crear" :createButton="false" 
        :editButton="false" :deleteButton="false" ref="listaTiposUnidad" 
        @seleccionar="seleccionar" :path="url + '/tipos-unidad/search'" :columns="[
            {
                display : 'Nombre',
                value : 'nombre'
            },
            {
                display : 'Descripción',
                value : 'descripcion'
            },
            {
                display : 'Fecha de creación',
                value : 'created_at'
            },
            {
                display : 'Fecha de modificación',
                value : 'updated_at'
            }
        ]">
        </k-table>
    </div>
</template>

<script>
export default {
    props : {
        filterStatus : {
            type : Boolean,
            required : false,
            default : true
        },
        searchButton : {
            type : Boolean,
            required : false,
            default : false
        }
    },
    data : function () {
        return {
            currentIndex : -1,
            url : url
        }
    },
    methods : {            
        seleccionar : function(currentTipoUnidad) {
            this.$emit('selected', currentTipoUnidad);
        }
    }

}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/tipos-unidad/ListaTiposUnidad.vue